import { render } from "./PosLeftbarPrescription copy.vue?vue&type=template&id=75793fd4&scoped=true"
import script from "./PosLeftbarPrescription copy.vue?vue&type=script&lang=js"
export * from "./PosLeftbarPrescription copy.vue?vue&type=script&lang=js"

import "./PosLeftbarPrescription copy.vue?vue&type=style&index=0&id=75793fd4&scoped=true&lang=css"
import "./PosLeftbarPrescription copy.vue?vue&type=style&index=1&id=75793fd4&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75793fd4"]])

export default __exports__